export default __webpack_public_path__ + "652ad50fea89f1a3c24f4f076e84580a.png";